"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@web3-react/core");
const react_1 = require("react");
const profile_1 = require("./components/profile");
const wallet_form_1 = require("./components/wallet-form");
const helper_1 = require("./helper");
require("./styles.scss");
const logo_1 = require("@components/icons/logo");
const button_1 = require("@components/button");
const popup_1 = require("@components/popup");
const Header = () => {
    const [isOpenedWalletPopup, setOpenedPopup] = (0, react_1.useState)(false);
    const context = (0, core_1.useWeb3React)();
    (0, helper_1.useInitialConnect)(context);
    const { library, deactivate, activate, connector, account } = context;
    const activateConnector = React.useCallback((connector) => __awaiter(void 0, void 0, void 0, function* () {
        yield activate(connector);
        setOpenedPopup(false);
    }), [library, activate, account]);
    const logout = React.useCallback(() => {
        deactivate();
        if (connector && "close" in (connector || {})) {
            connector.close();
        }
    }, [deactivate, connector]);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "c-header" },
            React.createElement("div", { className: "c-header__logo" },
                React.createElement(logo_1.Logo, null)),
            React.createElement("nav", { className: "c-header__nav" },
                React.createElement(react_router_dom_1.Link, { className: "c-header__nav-item g-link-alternative", to: "/tokens" }, "Tokens"),
                React.createElement(react_router_dom_1.Link, { className: "c-header__nav-item g-link-alternative", to: "/collections" }, "Collections"),
                React.createElement(react_router_dom_1.Link, { className: "c-header__nav-item g-link-alternative", to: "/users" }, "Users")),
            React.createElement("div", { className: "c-header__wallet not-mobile" }, account ? (React.createElement(profile_1.Profile, { disconnect: logout })) : (React.createElement(button_1.Button, { size: "small", onClick: () => setOpenedPopup(true), type: "primary" }, "Connect")))),
        React.createElement(popup_1.Popup, { isOpened: isOpenedWalletPopup, onClose: () => setOpenedPopup(false) },
            React.createElement(wallet_form_1.WalletForm, { activateConnector: activateConnector }))));
};
exports.Header = Header;
